"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_keyby_1 = __importDefault(require("lodash.keyby"));

function keyBy(collection, itteratee) {
  return lodash_keyby_1.default(collection, itteratee);
}

exports.keyBy = keyBy;